module.exports = __webpack_public_path__ + "static/media/f_hairstyle_wavy_medium_back.905eb947.png";